import { render, staticRenderFns } from "./CompareAgencies.vue?vue&type=template&id=3218289b&scoped=true"
import script from "./CompareAgencies.vue?vue&type=script&lang=js"
export * from "./CompareAgencies.vue?vue&type=script&lang=js"
import style0 from "./CompareAgencies.vue?vue&type=style&index=0&id=3218289b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3218289b",
  null
  
)

export default component.exports